import React, { Fragment } from "react";
import { useState } from "react";
import { getWeekOfYear } from "../../../function/WOY";

// Mui
import { Box, Modal, Button, Typography, TextareaAutosize, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";

// Redux
import { useSelector } from "react-redux";
import { getEOCActive } from "../../../reducer/eocActiveSlice";
import { getProfile } from "../../../reducer/profileSlice";
import ResponseDialog from "../ComponentReuse/ResponseDialog";
import EOCDetails from "../ComponentReuse/EOCDetails";

export default function EOCCancel(props) {
    const { open, onClose, dataTitle, onSuccess } = props;
    const profile = useSelector(getProfile);
    const eocActive = useSelector(getEOCActive);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);
    const [modalCancelEOC, setModalCancelEOC] = useState(false);
    const [cancellationReason, setCancellationReason] = useState("");

    const handleCancelEOC = async () => {
        if (Object.keys(cancellationReason).length !== 0) {
            try {
                let dateNow = new Date();
                let woy = getWeekOfYear(dateNow);
                let dataSend = {
                    eoc_id: eocActive?.eoc_id,
                    creator_id: profile?.inum,
                    creator_name: profile?.displayName,
                    org_id: profile?.org_id,
                    org_name: profile?.org_name,
                    remark: cancellationReason,
                    closed_eoc_timestamp: dateNow.getTime(),
                    closed_eoc_week: woy.week,
                    closed_eoc_year: woy.year,
                    phone: profile?.telephone,
                    email: profile?.mail,
                };
                const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/delete_eoc`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataSend),
                });
                if (response.ok) {
                    setStatus("ทำการยกเลิก EOC เสร็จสิ้น");
                    setModalResponse(true);
                } else {
                    setStatus("ไม่สามารถยกเลิก EOC ได้");
                    setModalResponse(true);
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            setStatus("กรุณาใส่เหตุผลที่ยกเลิก EOC");
            setModalResponse(true);
        }
    };

    const handleCloseResponse = () => {
        setModalResponse(false);
        if (Object.keys(cancellationReason).length !== 0) {
            onSuccess();
            setStatus("");
            setCancellationReason("");
            onClose();
        }
    };

    const handleTextValue = (e) => {
        setCancellationReason(e.target.value);
    };

    const handleCancel = () => {
        // setModalCancelEOC(false);
        handleCancelEOC();
    }

    const handleClose = () => {
        setStatus("");
        setCancellationReason("");
        onClose();
    };

    const handleCloseReason = () => {
        setCancellationReason("");
        setModalCancelEOC(false)
    };

    return (
        <Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
                className={modalCancelEOC ? 'hidden' : 'block'}
            >
                <DialogTitle className='py-3'>
                    <div>
                        <Typography variant="body1">ยกเลิก {dataTitle?.org_level}</Typography>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <EOCDetails eocData={eocActive} />
                </DialogContent>
                <DialogActions className='mx-4 my-2 gap-[10px]'>
                    <Button
                        onClick={() => setModalCancelEOC(true)}
                        variant="contained"
                        className='bg-[#cd6c4a] hover:bg-[#cd6c4a] w-28'
                    >
                        ยกเลิก EOC
                    </Button>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        className='w-28'
                        color='inherit'
                    >
                        ปิด
                    </Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />

            <Dialog
                maxWidth={'md'}
                open={modalCancelEOC}
            >
                <DialogContent>
                    <Typography variant="body1" className="mb-2">โปรดระบุเหตุผลที่ยกเลิก EOC</Typography>
                    <TextField
                        className="md:min-w-96"
                        id="outlined-multiline-details"
                        label=""
                        fullWidth
                        multiline
                        rows={4}
                        value={cancellationReason}
                        onChange={handleTextValue}
                    />
                </DialogContent>
                <DialogActions className='mx-4 my-2'>
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        className='bg-[#cd6c4a] hover:bg-[#cd6c4a] w-24'
                        disabled={cancellationReason === ""}
                    >
                        ตกลง
                    </Button>
                    <Button
                        onClick={handleCloseReason}
                        variant="outlined"
                        color="inherit"
                        className="w-24"
                    >
                        ยกเลิก
                    </Button>
                </DialogActions>
            </Dialog>

            {/* <Modal
                open={modalCancelEOC}
                sx={{
                    display: "flex",
                    maxWidth: "1650px",
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "#fff",
                        margin: "auto",
                        justifyContent: "center",
                        borderRadius: '5px',
                        width: "400px",
                        padding: "10px 20px"
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        <Typography sx={{ fontSize: 16 }}> เหตุผลที่ยกเลิก EOC </Typography>
                        <TextareaAutosize
                            onChange={handleTextValue}
                            style={{ width: "100%", height: "100px", borderRadius: "5px", marginTop: "10px" }}
                            aria-label="minimum height"
                            minRows={1}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                            <Button
                                size="small"
                                variant="outlined"
                                sx={{
                                    borderRadius: "5px",
                                    marginTop: "auto",
                                }}
                                onClick={handleCancel}

                            >
                                ตกลง
                            </Button>
                            <Button
                                size="small"
                                variant="outlined"
                                sx={{
                                    borderRadius: "5px",
                                    marginTop: "auto",
                                    marginLeft: "1rem",
                                }}
                                onClick={() => setModalCancelEOC(false)}

                            >
                                ปิด
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal> */}
        </Fragment>
    );

}
